import React, { Fragment } from 'react'
import PersonalDataFormSection from './FormPersonalData'
import FormErrorMessage from './FormErrorMessage'
import FormActionsRow from './FormActionsRow'
import { Col, Container, Row } from 'Components/Grid'
import Radio from 'Components/Radio'
import Datepicker from 'Components/Datepicker'
import Textarea from 'Components/Textarea'
import axios from 'axios'
import { isInvalid, validateEmail, validateLength, validateEmpty } from 'Utils/Validators'
import FormSuccessMessage from './FormSuccessMessage'
import LoadingSpinner from 'Components/LoadingSpinner'
import { gaPush } from 'Utils/ga_push'
import cn from 'classnames'
import {
  formSubmitErrorTracking,
  getTrackingDataFromElement,
  mockTrackedElement,
  consultationFormSubmitTracking
} from 'Utils/trackingAttributes'
import { ContactComponent } from './ContactComponent'
import Button from 'Components/Button'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import classNames from 'classnames/bind'

import styles from './styles.scss'
import { useNestedPayloadType } from './stateConfig'
import { gReCaptchaWebsiteKey } from './GoogleReCaptchaUtils'
import { FormErrorModal } from './FormErrorModal'
import { AdvertisementCommunicationInfo } from 'Containers/ContactForm/AdvertisementCommunicationInfo'

const cx = classNames.bind(styles)

class ConsultationAppointment extends ContactComponent {
  constructor(props) {
    super(props)

    this.state = {
      errors: {},
      type: 'Dealer Contact request',
      model: props.defaultModel || '',
      title: '',
      firstName: '',
      lastName: '',
      dealer: !!props.dealer.settings.leadsMimicDealerId
        ? props.dealer.settings.leadsMimicDealerId
        : props.dealer.id,
      telephone: '',
      email: '',
      country: 'Germany',
      language: 'de',
      termsAccepted: false,
      showTerms: false,
      emailOptIn: false,
      telephoneOptIn: false,
      smsOptIn: false,
      doubleOptIn: true,
      promotionalTermsAccepted: false,
      showPromotionalTerms: false,
      sent: false,
      market: 'MMD',
      campaign: props.sharedState.campaignCode || 'MMD_Beratungstermin_HWS',
      campaignType: '',
      assignToDealer: true,
      organisation: 'MMD Organization',
      modalOpened: false,
      loading: false,
      clientType: 'private',
      appointmentDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() + 8
      ),
      time: 'vormittags',
      appointmentType: 'im Autohaus',
      message: '',
      hwsconfig: window.hwsconfig || {},
      customerSupportMessage: '',
      errorApi: null
    }
  }

  componentDidMount() {
    const { sharedState, setSharedState, stateConfig } = this.props

    const script = document.createElement('script')
    script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${gReCaptchaWebsiteKey}`
    document.body.appendChild(script)

    if (!sharedState) {
      return
    }

    if (!sharedState.modalType || stateConfig.modaltypeToWriteInUrl) {
      this.props.updateMultipleUrlQuery({
        modaltype: stateConfig.modaltypeToWriteInUrl,
        showmodal: 'true'
      })
    }

    if (sharedState.carModel && sharedState.carModel !== this.state.model) {
      this.setState({ model: sharedState.carModel })
    }

    if (!!sharedState.leadsMimicDealerId) {
      this.setState({ dealer: sharedState.leadsMimicDealerId })
      setSharedState({ leadsMimicDealerId: null })
    }
  }

  componentWillUnmount = () => {
    this.props.updateGlobalContext(undefined, undefined, {
      selectedAccessoryPart: undefined,
      selectedAccessoryPartModel: undefined
    })
  }

  addCommentsToPayload(payload) {
    const { appointmentDate, time, appointmentType, message } = this.state
    const { leadLocation, globalContext, dealer } = this.props

    let selectedAccessoryPart =
      globalContext && globalContext.selectedAccessoryPart
        ? `\nZubehörteil: ${globalContext.selectedAccessoryPart}`
        : ''

    let comments = `
    Weitere Informationen:${selectedAccessoryPart}\nTerminanfrage für Beratung: ${appointmentType}\nPräferierte Zeit: ${appointmentDate}: ${time}\nKundenkommentar falls vorhanden: ${message}\n Ort der Leadabgabe: ${leadLocation} (Nutzer befand sich auf folgender Seite als die Terminanfrage gestellt wurde: ${
      window.location.toString().split('?')[0]
    })\nWas ist zu tun: Bitte kontaktieren Sie den Interessenten zeitnah.\nPS: Die Leadbearbeitung direkt in MACS bietet Ihnen viele komfortable Funktionen, wie z.B. eine direkte Emailvorlage für die Vereinbarung einer Online Beratung und/oder die direkte Übernahme der Daten in Ihren Kontaktpool.`

    if (
      [
        'SERVICE_REQUEST',
        'SERVICE_CONTACT',
        'REQUEST_FOR_CONSULTATION_WS',
        'SERVICE_BOOKING_FALLBACK',
        'REQUEST_FOR_CONSULTATION_OSBFB'
      ].includes(this.props.stateConfig.modalName)
    ) {
      selectedAccessoryPart =
        globalContext && globalContext.selectedAccessoryPart
          ? `\nDie Anfrage betraf folgende Zubehörteilenummer: ${
            globalContext.selectedAccessoryPartModel.partNumber
          } \n Angezeigter Preis auf Ihrer Webseite: ${
            dealer.settings.showAccessoryPrice
              ? globalContext.selectedAccessoryPartModel.priceInclFitting()
              : ''
          } ${dealer.settings.showAccessoryPrice ? 'EUR' : 'auf Anfrage'}`
          : ''
      const { isOsbUser } = window.dealer.settings
      comments = `Allgemeine Info: Es handelt sich hierbei um eine allgemeine Anfrage zu Ihren Serviceleistungen über das Formular "Serviceberater kontaktieren" auf der HWS. ${
        isOsbUser
          ? 'Ihre Online Terminbuchungsanfragen erhalten Sie gesondert per Email / MACS Anbindung.'
          : ''
      } \n Der/Die Websitebesucher:in befand sich auf folgender Seite als die Serviceanfrage gestellt wurde: ${
        window.location.toString().split('?')[0]
      } ${selectedAccessoryPart} \n Kundenkommentar: ${message} \n`
    }

    if (
      (this.props.stateConfig.modalName === 'REQUEST_FOR_CONSULTATION_OSBFB' ||
        this.props.stateConfig.modalName === 'SERVICE_BOOKING_FALLBACK') &&
      !globalContext.selectedAccessoryPart
    ) {
      comments = `Allgemeine Info: da Ihr Betrieb nicht an der Online-Werkstattermin-Buchung (OSB) teilnimmt, kann es sich bei dieser Anfrage über das Formular "Serviceberater kontaktieren" auf der HWS sowohl um eine allgemeine Anfrage zu Ihren Serviceleistungen als auch um eine Werkstatt-Terminanfrage handeln.\nDer/Die Websitebesucher:in befand sich auf folgender Seite als die Serviceanfrage gestellt wurde: ${
        window.location.toString().split('?')[0]
      } \n Kundenkommentar: ${message} \n`
    }

    return { ...payload, comments }
  }

  getPayload() {
    let payload = { ...this.state }
    const { stateConfig } = this.props
    const payloadKeys = Object.keys(stateConfig.payloadConfig)

    // filter active?
    Object.keys(payload).forEach(
      stateKey => !payloadKeys.includes(stateKey) && delete payload[stateKey]
    )

    if (payload.title === '') {
      delete payload.title
    }

    if (payloadKeys.includes('comments')) {
      payload = this.addCommentsToPayload(payload)
    }

    if (stateConfig.fieldsConfig.useNestedPayloadType) {
      return useNestedPayloadType(payload)
    }

    return payload
  }

  addAccessoryMarkToTracking(label) {
    const { globalContext } = this.props

    if (globalContext && globalContext.selectedAccessoryPart) {
      return `${label}_pa`
    }

    return label
  }

  addAppointmentTypeToTracking(label) {
    if (
      !this.props.dealer.settings.offersOnlineConsultation ||
      !this.props.stateConfig.fieldsConfig.showAppointmentType
    ) {
      return label
    }

    if (this.state.appointmentType === 'im Autohaus') {
      return `${label}_offline`
    }

    return `${label}_online`
  }

  onSend = () => {
    const {
      errors,
      firstName,
      lastName,
      email,
      customerSupportMessage,
      telephone
    } = this.state

    const { payloadConfig, trackingConfig, fieldsConfig, modalName } = this.props.stateConfig

    if (payloadConfig.firstName && payloadConfig.firstName.inputRequired)
      validateLength(errors, 'firstName', firstName, 1, 48)

    if (payloadConfig.lastName && payloadConfig.lastName.inputRequired)
      validateLength(errors, 'lastName', lastName, 1, 48)

    if (payloadConfig.email && payloadConfig.email.inputRequired) {
      if (!email) {
        errors.email = 'Bitte füllen Sie dieses Feld aus'
      } else {
        validateEmail(errors, 'email', email)
      }
    }
    validateLength(errors, 'telephone', telephone, 0, 25)
    validateEmpty(errors, 'customerSupportMessage', customerSupportMessage)

    if (isInvalid(errors)) {
      gaPush(
        getTrackingDataFromElement(
          mockTrackedElement(
            formSubmitErrorTracking(
              this.addAccessoryMarkToTracking(trackingConfig.errorLabel),
              undefined,
              undefined,
              {
                type: types => types.validation,
                errors
              }
            )
          )
        )
      )
      return this.setState({ errors })
    }

    let grecaptchaActionType = 'consultionappointmentrequest'
    if (
      [
        'REQUEST_FOR_CONSULTATION_WS',
        'SERVICE_BOOKING_FALLBACK',
        'SERVICE_REQUEST',
        'SERVICE_CONTACT'
      ].includes(modalName)
    ) {
      grecaptchaActionType = 'servicerequest'
    }

    this.setState({ loading: true })

    grecaptcha.ready(async () => {
      await grecaptcha
        .execute(gReCaptchaWebsiteKey, { action: grecaptchaActionType })
        .then(async token => {
          const payload = this.getPayload()
          payload.gReCaptchaToken = token
          if (
            fieldsConfig.requestUrl &&
            fieldsConfig.requestUrl === '/api/v1/service-appointments/'
          ) {
            if (payload.customer) {
              payload.customer.title = ' '
            }
            payload.title = ' '
          } else {
            if (payload.customer) {
              delete payload.customer.title
            }
            delete payload.title
          }
          await axios
            .post(fieldsConfig.requestUrl || '/api/v1/contact/', payload)
            .then(() => {
              gaPush(
                getTrackingDataFromElement(
                  mockTrackedElement(
                    consultationFormSubmitTracking(
                      this.addAppointmentTypeToTracking(
                        this.addAccessoryMarkToTracking(trackingConfig.trackingLabel)
                      )
                    )
                  )
                )
              )
              this.setState({ sent: true, loading: false })
            })
            .catch(err => {
              gaPush(
                getTrackingDataFromElement(
                  mockTrackedElement(
                    formSubmitErrorTracking(
                      this.addAccessoryMarkToTracking(trackingConfig.errorLabel),
                      undefined,
                      undefined,
                      {
                        type: types => (err.code === '-' ? types.timeout : types.server),
                        errors: err
                      }
                    )
                  )
                )
              )
              this.setState({ errorApi: err.data, loading: false })
            })
        })
      this.setState({ loading: false })
    })
  }

  handleChange = (value: any, property: string) => {
    const { errors } = this.state
    delete errors[property]

    if (['email', 'telephone'].includes(property)) {
      delete errors.email
      delete errors.telephone
    }

    this.setState({ [property]: value, errors })
    this.props.updateOneUrlQuery(value, property)
  }

  get showCarConfiguratorOnly() {
    if (!this.props.isConfigurator) {
      return false
    }

    const { hwsconfig } = this.state
    const { enableFormRequestAConsultation = true, enableFormCarConfigurator = true } = hwsconfig

    return !enableFormRequestAConsultation && enableFormCarConfigurator
  }

  get getAppointmentType() {
    const { showAppointmentType } = this.props.stateConfig.fieldsConfig
    if (!showAppointmentType || !this.props.dealer.settings.offersOnlineConsultation) return null

    const { errors, appointmentType } = this.state

    return (
      <Fragment>
        <Row>
          <Col>
            <h5
              className={cn(styles.sectionHeadline, {
                [styles.resetTopMargin]: this.props.isConsultationRequest
              })}
            >
              Terminmöglichkeiten
            </h5>
          </Col>
          <Col>
            <div className={styles.sectionInformation}>
              Ob direkt persönlich im Autohaus oder ganz bequem von Zuhause per Online Beratung -
              wir beraten Sie gerne zu unseren Fahrzeugen.
            </div>
          </Col>
        </Row>
        <Row>
          <Col cols={12} m={6} valign="center">
            <Radio
              label="im Autohaus"
              checked={appointmentType === 'im Autohaus'}
              name="appointmentType"
              value="im Autohaus"
              onChange={this.handleChange}
              errorMessage={errors.appointmentType}
            />
          </Col>
          <Col cols={12} m={6} valign="center">
            <Radio
              label="Online-Termin"
              checked={appointmentType === 'Online-Termin'}
              name="appointmentType"
              value="Online-Termin"
              onChange={this.handleChange}
              errorMessage={errors.appointmentType}
            />
          </Col>
        </Row>
      </Fragment>
    )
  }

  get getConfigurator() {
    const { showConfigurator } = this.props.stateConfig.fieldsConfig
    if (!showConfigurator) return null

    const { dealer } = this.props

    const link = 'https://www.mazda.de/konfigurator/?dealerid='.concat(
      dealer.id,
      '&utm_source=mazdahws&utm_medium=referral&utm_campaign=MMDKONFIGURATORHWS&utm_term=',
      dealer.id,
      '&utm_content=hws-configurator&campaignCode=MMD_KONFIGURATOR_HWS'
    )

    return (
      <Row>
        <Col>
          <div className={styles.configInfo}>
            <img
              className={styles.configIcon}
              alt=""
              src={`${process.env.ASSET_ENV_HOST}/assets/img/raedchen.svg`}
            />
            <div className={styles.iconLabel}>Konfigurieren Sie Ihren persönlichen Mazda</div>
          </div>
        </Col>
        <Col>
          <div className={styles.configInfo}>
            <img
              className={styles.configIcon}
              alt=""
              src={`${process.env.ASSET_ENV_HOST}/assets/img/upload.svg`}
            />
            <div className={styles.iconLabel}>
              Speichern Sie Ihre Auswahl und bringen Sie die Konfigurations-ID mit zur Beratung im
              Autohaus
            </div>
          </div>
        </Col>
        <Col>
          <div className={styles.configContainer}>
            <div className={styles.configLinkInfo}>
              Hier gelangen Sie zum Fahrzeugkonfigurator von mazda.de
            </div>
            <Button
              href={link}
              target="_blank"
              trackingLabel="Car Configurator"
              label="Jetzt konfigurieren"
            />
          </div>
          <div className={styles.separationLine}></div>
        </Col>
      </Row>
    )
  }

  get getAppointmentDate() {
    if (!this.props.stateConfig.fieldsConfig.showAppointmentDate) return null

    const { errors, appointmentDate, time } = this.state

    return (
      <Fragment>
        <Row>
          <Col>
            <h5 className={styles.sectionHeadline}>Ihr Terminwunsch</h5>
          </Col>
          <Col>
            {this.props.isConfigurator ? (
              <div className={styles.sectionInformation}>
                Möchten Sie lieber direkt mit uns gemeinsam Ihr Lieblingsfahrzeug konfigurieren?
                Bitte wählen Sie Ihren Wunschtermin aus. Bitte beachten Sie, dass es sich hierbei um
                eine Anfrage handelt und wir den Zeitpunkt nicht garantieren können. Sie erhalten
                schnellstmöglich eine Rückmeldung.
              </div>
            ) : (
              <div className={styles.sectionInformation}>
                Bitte wählen Sie Ihren Wunschtermin aus. Bitte beachten Sie, dass es sich hierbei um
                eine Anfrage handelt und wir den Zeitpunkt nicht garantieren können. Sie erhalten
                schnellstmöglich eine Rückmeldung.
              </div>
            )}
          </Col>
        </Row>
        <Row className={styles.marginS}>
          <Col cols={12} m={5}>
            <div className={styles.dateContainer}>
              <Datepicker
                name="appointmentDate"
                value={appointmentDate}
                onChange={this.handleChange}
                disabledDaysOfWeek={[0, 6]}
                minDate={
                  new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    new Date().getDate() + 1
                  )
                }
              />
            </div>
          </Col>
          <Col cols={12} m={3} valign="center">
            <Radio
              label="Vormittags"
              checked={time === 'vormittags'}
              name="time"
              value="vormittags"
              onChange={this.handleChange}
              errorMessage={errors.time}
            />
          </Col>
          <Col cols={12} m={4} valign="center">
            <Radio
              label="Nachmittags"
              checked={time === 'nachmittags'}
              name="time"
              value="nachmittags"
              onChange={this.handleChange}
              errorMessage={errors.time}
            />
          </Col>
        </Row>
      </Fragment>
    )
  }

  get getAppointmentDescription() {
    if (!this.props.stateConfig.fieldsConfig.showAppointmentDescription) return null

    const { errors, message } = this.state

    return (
      <Row>
        <Col>
          <h5 style={{ marginTop: 0 }} className={styles.sectionHeadline}>
            Nennen Sie uns ihren beratungswunsch
          </h5>
          <Textarea
            placeholder="Ihre Nachricht..."
            name="message"
            value={message}
            errorMessage={errors.message}
            onChange={this.handleChange}
          />
        </Col>
      </Row>
    )
  }

  get getAppointmentPersonalData() {
    if (!this.props.stateConfig.fieldsConfig.showAppointmentPersonalData) return null

    const {
      errors,
      firstName,
      lastName,
      title,
      email,
      telephone,
      customerSupportMessage
    } = this.state

    return (
      <PersonalDataFormSection
        errors={errors}
        handleChange={this.handleChange}
        firstName={firstName}
        lastName={lastName}
        title={title}
        email={email}
        telephone={telephone}
        hideAddress={true}
        hideTitle={true}
        secondaryHeader={'Für die Kontaktaufnahme benötigen wir Ihre Daten. Mit * gekennzeichnete Eingaben sind Pflicht.'}
        titleIsOptional={this.props.stateConfig.fieldsConfig.titleIsOptional}
        customerSupportMessage={customerSupportMessage}
      />
    )
  }

  get getTabs() {
    if (!this.props.stateConfig.fieldsConfig.showTabs) return null
    const { isOsbUser } = window.dealer.settings
    return (
      <div>
        {' '}
        <Tabs
          className={cx('fk-ws', 'fk-ws--tabs')}
          defaultIndex={this.props.consultationAppointmentTab}
          onSelect={index => {
            const targetModalType =
              index === 0
                ? 'REQUEST_FOR_CONSULTATION_FK'
                : isOsbUser
                  ? 'REQUEST_FOR_CONSULTATION_WS'
                  : 'REQUEST_FOR_CONSULTATION_OSBFB'
            this.props.updateMultipleUrlQuery({
              modaltype: targetModalType,
              showmodal: 'true'
            })

            this.props.updateTabIndex(index, targetModalType)
          }}
        >
          <TabList className={cx('fk-ws__tabs')}>
            <Tab className={cx('fk-ws__tab')}>Fahrzeugkauf</Tab>
            <Tab className={cx('fk-ws__tab')}>Service</Tab>
          </TabList>

          <TabPanel>
            <span></span>
          </TabPanel>
          <TabPanel>
            <span></span>
          </TabPanel>
        </Tabs>
      </div>
    )
  }

  get getOSBLink() {
    if (!this.props.stateConfig.fieldsConfig.showOSBLink) return null

    return (
      <Row>
        {this.props.stateConfig.fieldsConfig.osbTitle && (
          <Col>
            <h5 className={styles.sectionHeadline}>
              {this.props.stateConfig.fieldsConfig.osbTitle}
            </h5>
          </Col>
        )}
        {this.props.stateConfig.fieldsConfig.osbText && (
          <Col>
            <div className={styles.sectionInformation}>
              {this.props.stateConfig.fieldsConfig.osbText}
            </div>
          </Col>
        )}
        {this.props.stateConfig.fieldsConfig.showOSBLinkIcons && (
          <Fragment>
            <Col>
              <div className={styles.configInfo}>
                <img
                  className={styles.configIcon}
                  alt=""
                  src={`${process.env.ASSET_ENV_HOST}/assets/img/wartung.svg`}
                />
                <div className={styles.iconLabel}>
                  Übersicht unserer Wartungen, Serviceleistungen und Reparaturangebote
                </div>
              </div>
            </Col>
            <Col>
              <div className={styles.configInfo}>
                <img
                  className={styles.configIcon}
                  alt=""
                  src={`${process.env.ASSET_ENV_HOST}/assets/img/liste.svg`}
                />
                <div className={styles.iconLabel}>
                  Direkte Anzeige Ihrer individuell fälligen Fahrzeug-Wartung sowie etwaige offene
                  Serviceaktionen (FIN / Kennzeichen Eingabe notwendig)
                </div>
              </div>
            </Col>
            <Col>
              <div className={styles.configInfo}>
                <img
                  className={styles.configIcon}
                  alt=""
                  src={`${process.env.ASSET_ENV_HOST}/assets/img/termin.svg`}
                />
                <div className={styles.iconLabel}>Auswahl aller verfügbaren Termine</div>
              </div>
            </Col>
            <Col>
              <div className={styles.configInfo}>
                <img
                  className={styles.configIcon}
                  alt=""
                  src={`${process.env.ASSET_ENV_HOST}/assets/img/raedchen.svg`}
                />
                <div className={styles.iconLabel}>
                  Bestätigung, Verlegung und Stornierung des Termins problemlos online möglich
                </div>
              </div>
            </Col>
          </Fragment>
        )}
        <Col>
          <div className={styles.configContainer}>
            <div className={styles.configLinkInfo}>
              Hier gelangen Sie zur Werkstatt-Buchungsplattform der Mazda Motors (Deutschland) GmbH
            </div>
            <Button
              href={`https://werkstatt-termin.mazda.de/?mmeNsc=MMD&mmeDealerId=${this.state.dealer}&launchType=dealer&utm_source=hws&utm_medium=cta&utm_campaign=${this.state.campaign}`}
              target="_blank"
              trackingLabel="online_service_booking"
              trackingAction="open tab"
              label="Zur Terminbuchung"
            />
          </div>
        </Col>

        {this.props.stateConfig.fieldsConfig.showOSBSeparationLine && (
          <div className={styles.separationLine}></div>
        )}
      </Row>
    )
  }

  get getServiceRequest() {
    if (!this.props.stateConfig.fieldsConfig.showServiceRequest) return null

    const { globalContext } = this.props

    const selectedAccessoryPart =
      globalContext && globalContext.selectedAccessoryPart
        ? ` (Zubehörteil: ${globalContext.selectedAccessoryPart})`
        : ''

    return (
      <Row>
        {this.props.stateConfig.fieldsConfig.serviceRequestTitle && (
          <Col>
            <h5 className={styles.sectionHeadline}>
              {this.props.stateConfig.fieldsConfig.serviceRequestTitle}
            </h5>
          </Col>
        )}
        <Col>
          <div className={styles.sectionInformation}>
            {this.props.stateConfig.fieldsConfig.serviceRequestInformation ||
              'Sie haben eine Frage rund um die Themen Zubehör und Ersatzteile oder möchten einfach nur eine allgemeine Frage stellen? Bitte lassen Sie uns wissen, wie wir Ihnen weiterhelfen können.'}
          </div>
        </Col>
        <Col>
          <h5 className={styles.sectionHeadline}>
            Ihre Serviceanfrage an uns {`${selectedAccessoryPart}`}
          </h5>
        </Col>
        <Col>
          <Textarea
            placeholder="Ihre Nachricht..."
            name="message"
            value={this.state.message}
            errorMessage={this.state.errors.message}
            onChange={this.handleChange}
          />
        </Col>
      </Row>
    )
  }

  get getInformationAndButtons() {
    if (!this.props.stateConfig.fieldsConfig.showInformationAndButtons) return null

    const { errors, emailOptIn, telephoneOptIn } = this.state
    const { onAbort, dealer } = this.props

    if (!this.state.gReCaptchaToken || this.state.gReCaptchaToken === '') {
      this.state.gReCaptchaToken = localStorage.getItem('_grecaptcha')
    }

    return (
      <Fragment>
        <Row>
          <Col cols={12}>
            <AdvertisementCommunicationInfo
              dealer={dealer}
              emailOptIn={emailOptIn}
              errors={errors}
              setEmailOptIn={(value) => {
                this.handleChange(value, 'emailOptIn')
              }}
              setTelephoneOptIn={(value) => {
                this.handleChange(value, 'telephoneOptIn')
              }}
              telephoneOptIn={telephoneOptIn}
            />
          </Col>
        </Row>
        <FormErrorMessage errors={errors} />
        <FormActionsRow onAbort={onAbort} onSend={this.onSend} />
      </Fragment>
    )
  }

  get getInformationAndButtonsTypeService() {
    if (!this.props.stateConfig.fieldsConfig.showInformationAndButtonsTypeService) return null

    const { errors, emailOptIn, telephoneOptIn } = this.state
    const { onAbort, dealer } = this.props

    if (!this.state.gReCaptchaToken || this.state.gReCaptchaToken === '') {
      this.state.gReCaptchaToken = localStorage.getItem('_grecaptcha')
    }

    return (
      <Fragment>
        <Row>
          <Col cols={12}>
            <AdvertisementCommunicationInfo
              dealer={dealer}
              emailOptIn={emailOptIn}
              errors={errors}
              setEmailOptIn={(value) => {
                this.handleChange(value, 'emailOptIn')
              }}
              setTelephoneOptIn={(value) => {
                this.handleChange(value, 'telephoneOptIn')
              }}
              telephoneOptIn={telephoneOptIn}
            />
          </Col>
        </Row>

        <FormErrorMessage errors={errors} />
        <FormActionsRow onAbort={onAbort} onSend={this.onSend} />
      </Fragment>
    )
  }

  render() {
    const { sent, loading } = this.state

    if (this.state.errorApi) {
      if (this.state.errorApi.error.status) {
        return <FormErrorModal dealer={window.dealer} />
      }
    }

    if (sent) {
      return <FormSuccessMessage />
    }

    if (loading) {
      return <LoadingSpinner label="Ihre Anfrage wird bearbeitet" />
    }

    if (this.showCarConfiguratorOnly) {
      return <Container>{this.getConfigurator}</Container>
    }

    return (
      <Fragment>
        <Container>
          <Row className={styles.marginS}>
            <Col>
              <h2>{this.props.stateConfig.mainHeader}</h2>
            </Col>
          </Row>
        </Container>
        <Container>
          {this.getTabs}
          {this.getOSBLink}
          {this.getServiceRequest}
          {this.getConfigurator}
          {this.getAppointmentType}
          {this.getAppointmentDate}
          {this.getAppointmentDescription}
          {this.getAppointmentPersonalData}
          {this.getInformationAndButtons}
          {this.getInformationAndButtonsTypeService}
        </Container>
      </Fragment>
    )
  }
}

export default ConsultationAppointment
